module.exports = __webpack_public_path__ + "static/media/sanofi.07e159b5.png";